import { Content } from '@trufla-technology/trumarket-react-design-system';

export const NewCompany = () => {
  return (
    <Content>
      <p>TODO</p>
      <p>some form</p>
    </Content>
  );
};
